export const MENUITEMS = [
	{
		path: '/dashboard',
		icon: 'desktop',
		title: 'Dashboard',
		type: 'link'
	},

];
